import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormationState } from '../reducers/formation.reducers';

// Feature selector
export const selectFormationState = createFeatureSelector<FormationState>('formation');

// Formations list
export const selectAllFormations = createSelector(
  selectFormationState,
  (state: FormationState) => state.formations || []
);

export const selectFormationsLoading = createSelector(
  selectFormationState,
  (state: FormationState) => state.loading
);

// Active formations
export const selectActiveFormations = createSelector(
  selectAllFormations,
  (formations) => formations.filter(f => f.status === 'active')
);

// Selected formation
export const selectSelectedFormation = createSelector(
  selectFormationState,
  (state: FormationState) => state.selectedFormation
);

export const selectSelectedFormationLoading = createSelector(
  selectFormationState,
  (state: FormationState) => state.loadingDetail
);

// Next occurrence
export const selectNextOccurrence = createSelector(
  selectFormationState,
  (state: FormationState) => state.nextOccurrence
);

export const selectNextOccurrenceLoading = createSelector(
  selectFormationState,
  (state: FormationState) => state.loadingOccurrence
);

// Error
export const selectFormationError = createSelector(
  selectFormationState,
  (state: FormationState) => state.error
);

// Default formation (first active or first in list)
export const selectDefaultFormation = createSelector(
  selectAllFormations,
  (formations) => {
    if (!formations || formations.length === 0) {
      return null;
    }
    const activeFormations = formations.filter(f => f.status === 'active');
    return activeFormations.length > 0 ? activeFormations[0] : formations[0];
  }
);

// Formation by ID
export const selectFormationById = (formationId: number) => createSelector(
  selectAllFormations,
  (formations) => formations.find(f => f.id === formationId)
);

// Has formations
export const selectHasFormations = createSelector(
  selectAllFormations,
  (formations) => formations.length > 0
);

// Has active formations
export const selectHasActiveFormations = createSelector(
  selectActiveFormations,
  (formations) => formations.length > 0
);
